/**
 * @generated SignedSource<<04b02ca14ec701a6fc4ab8ec40981bc0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRecentlySoldItems_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedThinBrowseItemTrackingProvider_viewer" | "SharedItemTile_viewer">;
  readonly " $fragmentType": "SbSharedRecentlySoldItems_viewer";
};
export type SbSharedRecentlySoldItems_viewer$key = {
  readonly " $data"?: SbSharedRecentlySoldItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRecentlySoldItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRecentlySoldItems_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedThinBrowseItemTrackingProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d93eccac4ebfc0ebbb87e921f5678147";

export default node;
